var path = 'areas/master/getting-started/views/progress_step.html';
var html = "<div> <div class=progress-container> <orbicular progression=current total=100> <img ng-src={{imgSrc}} width=35 height=30 alt={{header}} /> </orbicular> </div> <div class=title>{{header}}</div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/views/progress_step.html
// module id = 1591157848509763
// module chunks = 1